import { useEffect, useRef } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

// T60: a new page (pathname change, or ?page= change) starts at the top. Kept: Back/Forward (POP) restores, #anchors
// scroll to their target, and same-page filter/sort tweaks or URL-driven drawers (search/hash only) don't jump.
export function ScrollToTop() {
  const { pathname, search, hash } = useLocation();
  const nav = useNavigationType();
  const prev = useRef({ pathname, page: new URLSearchParams(search).get("page") });
  useEffect(() => {
    const page = new URLSearchParams(search).get("page");
    const moved = pathname !== prev.current.pathname || page !== prev.current.page;
    prev.current = { pathname, page };
    if (!moved || nav === "POP") return;
    if (hash) {
      requestAnimationFrame(() => document.getElementById(decodeURIComponent(hash.slice(1)))?.scrollIntoView());
      return;
    }
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, search, hash, nav]);
  return null;
}
